__turbopack_context__.v({
  "className": "archivo_fbda5a80-module__gtrUMq__className",
  "variable": "archivo_fbda5a80-module__gtrUMq__variable",
});
